module.exports = __webpack_public_path__ + "img/806.389943b6.png";